import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <>
            <div className="bottom py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4">
                            <div className="bottom-logo">
                            <a href="/">
  <img className="pb-3" src="images/gps.png" alt="Tendex Logo" />
</a>
                                <p>
                                Mutual Funds are a powerful and flexible investment tool designed for precision, diversification, and transparency.                                </p>
                            </div>
                        </div>

                        <div className="col-xl-2">
                            <div className="bottom-widget">
                                <h4 className="widget-title">Quick Link</h4>
                                <ul>
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/career">Career</Link></li>
                                    <li><Link to="https://bloggps.torbitmultisoft.in/">Blogs</Link></li>
                                    <li><Link to="/RetirementCalculator">Calculator</Link></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-xl-2">
                            <div className="bottom-widget">
                                <h4 className="widget-title">Support</h4>
                                <ul>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                    {/* <li><Link to="#">FAQ</Link></li> */}
                                    {/* <li><Link to="#">Blog</Link></li>
                                    <li><Link to="#">Helpdesk</Link></li> */}
                                </ul>
                            </div>
                        </div>

                        <div className="col-xl-4">
                            <div className="bottom-widget">
                                <h4 className="widget-title">Our Services</h4>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <ul>
                                            <li><Link to="MutualFundPage">Mutual Fund</Link></li>
                                            <li><Link to="LoanAgainstSecuritiesPage">Loan Against Securities</Link></li>
                                            <li><Link to="BondPage">Bond</Link></li>
                                            <li><Link to="AIFPage">AIF</Link></li>
                                            <li><Link to="ResearchAnalystPage">Research Analyst</Link></li>
                                            <li><Link to="GlobalAccessPage">Global Access</Link></li>
                                        </ul>
                                    </div>
                                    <div className="col-xl-6">
                                        <ul>
                                           
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="copyright">
                                <p>© Copyright 2025 <a href="#">GPS</a> | All Rights Reserved</p>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="footer-social">
                                <ul>
                                    <li><a href="https://www.facebook.com/" target='blank'><i className="bi bi-facebook"></i></a></li>
                                    <li><a href="https://x.com/" target='blank'><i className="bi bi-twitter"></i></a></li>
                                    <li><a href="https://in.linkedin.com/" target='blank'><i className="bi bi-linkedin"></i></a></li>
                                    <li><a href="https://youtube.com/" target='blank'><i className="bi bi-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
